export type Tone = "ok" | "warn" | "err" | "unknown";

export function Badge({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function machineStatusTone(status: string): Tone {
  if (status === "active") return "ok";
  if (status === "pending") return "warn";
  if (status === "revoked") return "err";
  return "unknown";
}

export function licenseStatusTone(status: string): Tone {
  if (status === "active") return "ok";
  if (status === "past_due" || status === "grace_period") return "warn";
  return "err";
}
